export const UnitFirmList = [
  {
    label: "企业ID",
    text: "id",
    align: "center",
  },
  {
    label: "企业名称",
    text: "name",
    align: "center",
    width: "150",
  },
  {
    label: "授权到期时间",
    text: "licensedLeftAt",
    align: "center",
    width: "200",
    formatter: true,
  },
  {
    label: "注册时间",
    text: "createdAt",
    align: "center",
    width: "200",
  },
  {
    label: "启用状态",
    text: "status",
    align: "center",
    formatter: true,
  },
];

export const UnitPlatformRoleList = [
  {
    label: "角色ID",
    text: "id",
    align: "center",
  },
  {
    label: "角色名称",
    text: "roleName",
    align: "center",
  },
  {
    label: "创建人",
    align: "center",
    text: "createBy",
  },
  {
    label: "创建时间",
    align: "center",
    text: "createTime",
  },
  {
    label: "启用状态",
    text: "status",
    align: "center",
    formatter: true,
  },
];

export const UserList = [
  {
    label: "角色",
    text: "roleName",
    align: "center",
  },
  {
    label: "手机号",
    text: "mobile",
    align: "center",
  },
  {
    label: "真实姓名",
    text: "userName",
    align: "center",
  },
  {
    label: "性别",
    text: "gender",
    align: "center",
    formatter: true,
  },
  {
    label: "操作人",
    text: "ucreateBy",
    align: "center",
  },
  {
    label: "操作时间",
    text: "ucreateTime",
    align: "center",
  },
  {
    label: "启用状态",
    text: "rstatus",
    align: "center",
    formatter: true,
  },
];

export const userMessage = [
  {
    label: "手机号",
    text: "mobile",
    align: "center",
  },
  {
    label: "真实姓名",
    text: "userName",
    align: "center",
  },
  {
    label: "性别",
    text: "gender",
    align: "center",
    formatter: true,
  },
  {
    label: "最后操作",
    text: "updateBy",
    align: "center",
    formatter: true,
  },
  {
    label: "更新时间",
    text: "updateTime",
    align: "center",
    formatter: true,
  },
  {
    label: "启用状态",
    text: "status",
    align: "center",
    formatter: true,
  },
];

export const merchantMode = [
  {
    label: "模式ID",
    text: "id",
    align: "center",
  },
  {
    label: "模式名称",
    text: "name",
    align: "center",
  },
  {
    label: "企业数量",
    text: "merchantList",
    align: "center",
    formatter: true,
  },
  {
    label: "添加人",
    text: "createBy",
    align: "center",
  },
  {
    label: "创建时间",
    text: "createTime",
    align: "center",
  },
];

export const ContentServiceProvider = [
  {
    label: "服务商编号",
    text: "id",
    width: "100",
    align: "center",
  },
  {
    label: "服务商名称",
    text: "title",
    align: "center",
  },
  {
    label: "服务商类型",
    text: "providerType",
    width: "100",
    align: "center",
    formatter: true,
  },
  {
    label: "内容分类",
    text: "csType",
    width: "140",
    align: "center",
    formatter: true,
  },
  {
    label: "联系人",
    text: "contactName",
    width: "160",
    align: "center",
  },
  {
    label: "手机号",
    text: "contactMobile",
    width: "160",
    align: "center",
  },
  {
    label: "创建人",
    text: "createBy",
    width: "160",
    align: "center",
  },
  {
    label: "创建时间",
    text: "createTime",
    width: "160",
    align: "center",
  },
  {
    label: "使用状态",
    text: "isUse",
    width: "100",
    align: "center",
    status: true,
    btnName: "providerStatus",
  },
];

export const CommonList = [
  {
    label: "接口名称",
    text: "info",
    align: "center",
  },
  {
    label: "接口地址",
    text: "path",
    align: "center",
  },
];

export const ShopTypeList = [
  {
    label: "门店类型名称",
    text: "name",
    align: "center",
  },
  {
    label: "关联业态",
    text: "formats",
    align: "center",
    formatter: true,
  },
];

export const ShoppeCheckList = [
  {
    label: "柜组ID",
    text: "id",
    align: "center",
  },
  {
    label: "柜组名称",
    text: "name",
    align: "center",
  },
  {
    label: "柜组类型",
    text: "type",
    align: "center",
    formatter: true,
  },
  {
    label: "开通功能",
    text: "useCate",
    align: "center",
    formatter: true,
  },
  {
    label: "审核状态",
    text: "verify",
    align: "center",
    formatter: true,
  },
  {
    label: "发起人",
    text: "createBy",
    align: "center",
    formatter: true,
  },
  {
    label: "发起时间",
    text: "createTime",
    align: "center",
    formatter: true,
  },
];

export const logListFields = [
  {
    label: "操作模块",
    text: "moduleName",
  },
  {
    label: "操作事件",
    text: "eventName",
  },
  {
    label: "操作对象名称",
    text: "title",
  },
  {
    label: "操作人",
    text: "operName",
  },
  {
    label: "操作时间",
    text: "createdAt",
  },
];

export const userBatchList = [
  {
    label: "导入时间",
    text: "createdAt",
    align: "center",
    width: "170",
  },
  {
    label: "完成时间",
    text: "endAt",
    align: "center",
    width: "170",
  },
  {
    label: "操作人",
    text: "createdBy",
    align: "center",
  },
  {
    label: "导入总数",
    text: "allCount",
    align: "center",
  },
  {
    label: "导入成功数",
    text: "successCount",
    align: "center",
  },
  {
    label: "导入失败数",
    text: "failCount",
    align: "center",
  },
  {
    label: "状态",
    text: "status",
    align: "center",
    formatter: true,
  },
];

export const belongSystemList = [
  {
    label: "权限",
    value: 0,
  },
  {
    label: "商城",
    value: 1,
  },
  {
    label: "会员",
    value: 2,
  },
];

export const WXMerchantList = [
  {
    label: "所属企业",
    text: "merchantName",
    align: "center",
    width: "200",
  },
  {
    label: "申请单号",
    text: "wxOrderId",
    align: "center",
    width: "200",
  },
  {
    label: "支付商户号",
    text: "merId",
    align: "center",
    width: "200",
  },
  {
    label: "营业执照名称",
    text: "licenseName",
    align: "center",
    width: "250",
  },
  {
    label: "账号申请状态",
    text: "statusName",
    align: "center",
    width: "150",
  },
  {
    label: "驳回备注",
    text: "remark",
    align: "center",
    width: "250",
    tooltip: true,
  },
  {
    label: "分账功能",
    text: "1",
    align: "center",
    width: "150",
  },
  {
    label: "最后更新时间",
    text: "updatedAt",
    align: "center",
    width: "200",
  },
  {
    label: "申请人",
    text: "updatedUser",
    align: "center",
    width: "150",
  },
  {
    label: "发起申请时间",
    text: "applyTime",
    align: "center",
    width: "200",
  },
];
